<template>
  <div>
    <b-row>
      <b-col xl="2" md="4" sm="12" cols="12">
        <b-form-group
          id="fieldset-2"
          label=""
        >
          <div class="filter-search-label">
            <span>Дата создания</span>
          </div>
          <ctk-date-time-picker
            v-model="datePickerValue"
            id="DateTimePickerPackages"
            label="Дата с ... дата по ..."
            color="#40b539"
            locale="ru"
            range
            noLabel
            @is-hidden="$emit('onSelectDate')"
            :disabled="searchByPackageNumber"
            :custom-shortcuts="customShortcuts"
            format="YYYY-MM-DD HH:mm"
            formatted="ll"
          >
          </ctk-date-time-picker>
        </b-form-group>
      </b-col>
      <b-col class="search-group" xl="3" md="4" sm="12" cols="12">
        <b-form-group
          id="fieldset-2"
          label="Статусы пакетов"
          label-for="filter-by-status"
          label-class="search-form-label"
        >
          <treeselect id="filter-by-status"
                      :disabled="!statuses || (statuses.length === 0) || !!searchByPackageNumber"
                      name="filter-by-status"
                      :multiple="true"
                      :options="statuses"
                      v-model="selectedStatus"
                      placeholder="Выбрать"
                      noResultsText="Ничего не найдено..."
                      :clearable=true
                      :label="'Статусы пакетов'"
                      data-vv-as="Статусы пакетов"
          >
            <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
          </treeselect>
        </b-form-group>
      </b-col>
      <b-col class="search-group" xl="2" md="4" sm="12" cols="12">
        <b-form-group
          id="fieldset-3"
          label="Категория"
          label-for="filter-by-category"
          label-class="search-form-label"
        >
          <b-form-select style="position: relative; top: -1px; padding-left: 12px;" id="filter-by-category" v-model="selectedCategory" :options="optionsCategory" :disabled="!!searchByPackageNumber"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col class="search-group" xl="3" md="10" sm="10" cols="9">
        <b-form-group
          id="fieldset-4"
          label=""
        >
          <div id="search-option" class="filter-search-label">
            <span @click="changeSearchType('regular')" :class="{ 'active-search': !regularSearch, 'search-variant': true }">
              {{ this.searchTypes[0].text }}
            </span>&nbsp;/&nbsp;
            <span @click="changeSearchType('byPackageNumber')" :class="{ 'active-search': !searchByPackageNumber, 'search-variant': true }">{{ this.searchTypes[1].text }}</span>
          </div>
          <b-input-group>
            <b-form-input v-if="regularSearch" id="search-input" v-model="searchText" placeholder="Поиск"></b-form-input>
            <b-form-input v-else id="search-input-by-pid" v-model="searchTextByPid" placeholder="Поиск по номеру пакета"></b-form-input>
            <div class="container_search-close" @click="clearField">
              <span class="search-close">&#215;</span>
            </div>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="2" cols="3" class="d-flex align-items-center justify-content-xl-start justify-content-sm-end">
        <b-button
          variant="success"
          :disabled="!portalId || !datePickerValue"
          @click="$emit('onSearch')"
          size="sm"
          squared
        >Поиск</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" v-if="piportals && piportals.length > 1">
        <b-form-group
          id="fieldset-1"
          label="Выберите сервер"
        >
          <b-form-select v-model="portalId"
                         id="select-server"
                         :options="portals"
                         value-field="alias"
                         text-field="name"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import CtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import moment from 'moment'
  export default {
    name: "PackagesListFilterSearch",
    components: {
      CtkDateTimePicker,
      Treeselect
    },
    props: ['defaultDate'],
    data () {
      return {
        datePickerValue: { start: '', end: '' },
        customShortcuts: [
          { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
          { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
          { key: 'thisYear', label: 'Этот год', value: 'year' }
        ],
        currentOptionsCategory: null,
        optionsCategory: [
          { value: '', text: 'Выбрать' },
          { value: 'transport', text: 'Транспорт' },
          { value: 'organization', text: 'Организации' },
          { value: 'waybill', text: 'Номер накладной' },
          { value: 'delivery', text: 'Место доставки' }
        ],
        selectedCategory: '',
        selectedStatus: null,
        searchText: '',
        searchTextByPid: '',
        selectedSearchType: '1',
        searchTypes: [
          { text: 'Общий', value: '1' },
          { text: '№ пакета', value: '2' }
        ],
        portalId: null,
        regularSearch: true,
        searchByPackageNumber: false
      }
    },
    watch: {},
    computed: {
      ...mapState(
        {
          piportals: state => state.authorization.userInfo.piportals,
          statuses: state => state.packages.statuses
        }
      )
    },
    mounted () {
      if (this.defaultDate) {
        localStorage.removeItem('datePickerValue_start')
        localStorage.removeItem('datePickerValue_end')
        this.datePickerValue.start = this.moment(new Date()).add(-2, 'days').format('YYYY-MM-DD 00:00')
        this.datePickerValue.end = this.moment(new Date()).format('YYYY-MM-DD 23:59')
      } else {
        if (localStorage.getItem('datePickerValue_start')) {
          this.datePickerValue.start = localStorage.getItem('datePickerValue_start')
        }
        if (localStorage.getItem('datePickerValue_end')) {
          this.datePickerValue.end = localStorage.getItem('datePickerValue_end')
        }
      }
      if (this.piportals && this.piportals.length === 1) {
        this.portalId = this.piportals[0].alias.replace(' ', '')
      } else {
        this.getPortalsList().then(
          () => {
            this.portalId = this.portals[0].alias.replace(' ', '')
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    methods: {
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      clearField () {
        this.searchText = ''
        this.searchTextByPid = ''
      },
      changeSearchType (type) {
        if (type === 'regular') {
          this.regularSearch = true
          this.searchByPackageNumber = false
          this.searchTextByPid = ''
          this.datePickerValue.start = localStorage.getItem('datePickerValue_start')
          this.datePickerValue.end = localStorage.getItem('datePickerValue_end')
        }
        if (type === 'byPackageNumber') {
          this.searchText = ''
          this.regularSearch = false
          this.searchByPackageNumber = true
          this.selectedCategory = ''
          this.selectedStatus = []
          this.datePickerValue.start = null
          this.datePickerValue.end = null
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
